function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  ", "\n  &::before {\n    content: '';\n    height: 0;\n    display: block;\n    padding-bottom: ", ";\n  }\n\n  & > * {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n  }\n\n  & > img,\n  & > video {\n    object-fit: cover;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { layout } from 'styled-system';
import { Box as BaseBox } from '../index';
var Box = styled(function (props) {
  return /*#__PURE__*/React.createElement(BaseBox, props);
})(_templateObject(), layout, function (_ref) {
  var ratio = _ref.ratio;
  return "calc(100% / " + ratio + ")";
});

var AspectRatio = function AspectRatio(_ref2) {
  var ratio = _ref2.ratio,
      children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, ["ratio", "children"]);

  return /*#__PURE__*/React.createElement(Box, _extends({
    ratio: ratio
  }, props), children);
};

AspectRatio.propTypes = process.env.NODE_ENV !== "production" ? {
  ratio: PropTypes.number
} : {};
AspectRatio.defaultProps = {
  ratio: 16 / 9
};
export default AspectRatio;